module.exports = "static/assets/00aa0c4320b93631ab3c223604ead431.svg";